import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ProductGroupService } from './product-group.service';
import { AttributesService } from './attributes.service';
import { WorkflowStatesService } from './workflow-states.service';
import { MasterGroupService } from './master-group.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  isUserLoggedIn: any = false;
  isUserSignedUp: any = false;
  refreshAlertRemaining: number = 2;
  headerName: BehaviorSubject<string>;

  constructor(
    private http: HttpClient,
    private routes: Router,
    private productGroupService: ProductGroupService,
    private attributesServcie: AttributesService,
    private workflowStatesService: WorkflowStatesService,
    private masterService: MasterGroupService
  ) { 
    this.headerName = new BehaviorSubject('');
  }

  createLoginForm() {
    return new UntypedFormGroup({
      'username': new UntypedFormControl(null, Validators.required),
      'password': new UntypedFormControl(null, Validators.required),
      'otp': new UntypedFormControl(null)
    });
  }

  createSignUpForm() {
    return new UntypedFormGroup({
      'company_name': new UntypedFormControl(null, Validators.required),
      'username': new UntypedFormControl(null, Validators.required),
      'password': new UntypedFormControl(null, Validators.required),
      'email_id': new UntypedFormControl(null, [Validators.required, Validators.email]),
      'contact_no': new UntypedFormControl(null, Validators.required),
      'otp': new UntypedFormControl(null)
    });
  }

  createCustomerDetailsForm() {
    return new UntypedFormGroup({
      'company_name': new UntypedFormControl(sessionStorage.getItem('company_name'), Validators.required),
      'industry_id': new UntypedFormControl('', Validators.required),
      'country_id': new UntypedFormControl('', Validators.required),
      'state_id': new UntypedFormControl('', Validators.required),
      'street': new UntypedFormControl(''),
      'area': new UntypedFormControl(''),
      'city': new UntypedFormControl(''),
      'pincode': new UntypedFormControl(''),
      'contact_no': new UntypedFormControl(sessionStorage.getItem('contact_no'), Validators.required),
      'contact_no_2': new UntypedFormControl(null),
      'gst_no': new UntypedFormControl(''),
      'pan_no': new UntypedFormControl('')
    });
  }

  createPrefixForm(prefixTypes: any) {
    const prefixForm = new UntypedFormGroup({});
    for (let i = 0; i < prefixTypes.length; i++) {
      prefixForm.addControl(prefixTypes[i]['id'], new UntypedFormGroup({
        prefix : new UntypedFormControl(''),
        counter : new UntypedFormControl(1),
      }));
    }
    return prefixForm;
  }

  loginUserApi(requestMethod: string, data: any) {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + 'login_user/';

      if (!data) {
        return reject();
      }

      this.http.request(requestMethod, endpointUrl, {body: data, withCredentials: true})
      .subscribe(
        (response: any) => {
          console.log('User Logged In Successfully......');
          resolve(response);
        },
        error => {
          console.log(error.error['detail']);
          reject(error.error['detail']);
        }
      );
    });
  }

  logoutUserApi(requestMethod: string) {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + 'logout_user/';

      this.http.request(requestMethod, endpointUrl, {body: {}, withCredentials: true})
      .subscribe(
        response => {
          console.log('User Logged Out Successfully......');
          this.logoutUserUpdates();
          resolve(response);
        },
        error => {
          console.log(error.error);
          alert('User Log Out Failed...!!!!');
          reject(error.error);
        }
      );
    });
  }

  logoutUserUpdates() {
    this.resetUserDetails();
    this.resetListDetails();
    this.routes.navigate(['/login']);
  }

  signUpUserApi(requestMethod: string, data: any) {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + 'sign_up_user/';

      if (!data) {
        return reject();
      }

      this.http.request(requestMethod, endpointUrl, {body: data})
      .subscribe(
        response => {
          console.log('User Signed Up Successfully......');
          resolve(response);
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      );
    });
  }

  verifyOTPApi(requestMethod: string, data: any) {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + 'verify_otp_via_email/';

      if (!data) {
        return reject();
      }

      this.http.request(requestMethod, endpointUrl, {body: data})
      .subscribe(
        response => {
          console.log('User Email Verified Successfully...!!');
          resolve(response);
        },
        error => {
          console.log('User Email Verification Failed');
          console.log(error.error);
          reject(error.error);
        }
      );
    });
  }

  verifyOTP(data: any) {
    if (!(data['otp'] && data['email_id'])) {
      alert('Please Enter OTP');
      return;
    }
    const status = this.verifyOTPApi('POST', data);
    status.then((response: any) => {
      this.setSessionStorage(response);
      this.routes.navigate(['/login/addcompanydetails'])
  })
    .catch((error: any) => 
      {
        alert(error['detail']);
      }
    )
  }

  getCompanyDetails() {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + 'company_details/';
      let data: any = {'id': sessionStorage.getItem('user_id')};
      this.http.request('GET', endpointUrl, {params: data})
      .subscribe(
        response => {
          if (response) {
            console.log('User Details Received......');
            this.updatePrefixesDataForForm(response);
            resolve(response);
          }
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      );
    });
  }

  addUpdateCompanyDetails(data: any, requestMethod: string) {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + 'company_details/';

      data['id'] = sessionStorage.getItem('user_id');
    
      this.http.request(requestMethod, endpointUrl, {body: data})
      .subscribe(
        response => {
          console.log('Successfully udpated Company Details');
          resolve(response);
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      )
    })
  }

  updatePrefixesDataForForm(response: any) {
    const updatedPrefixData: any = {};
    for (let prefix of response['prefixes']) {
      updatedPrefixData[prefix['id_type']] = {'prefix': prefix['id_prefix'], 'counter': prefix['counter']}
    }
    response['prefixes'] = updatedPrefixData;
  }

  checkAndSetUserDetailsFromSessionStorage() {
    let userDetails: any = {'user_id': null, 'access': null, 'refresh': null, 'is_owner_verified': null};
    for (const key in userDetails) {
      if (sessionStorage.getItem(key) === null) {
        this.resetUserDetails();
        this.routes.navigate(['/login']);
        return false;
      }
    }
    this.isUserLoggedIn = true;
    this.headerName.next(sessionStorage.getItem('company_name') || '');
    return true;
  }

  setSessionStorage(response: any, isOwnerVerified: boolean = false) {
    for (const key in response) {
      sessionStorage.setItem(key, response[key]);
    }
    const dt = new Date();
    sessionStorage.setItem('access_time', dt.toString());
    sessionStorage.setItem('refresh_time', dt.toString());
    this.refreshAlertRemaining = 2;
    if (!isOwnerVerified) {
      this.isUserSignedUp = true;
      return;
    }
    this.isUserLoggedIn = true;
    this.headerName.next(response['company_name']);
  }

  resetUserDetails() {
    this.isUserSignedUp = false;
    this.isUserLoggedIn = false;
    this.headerName.next('');
    sessionStorage.clear();
  }

  resetListDetails() {
    this.productGroupService.productGroupList = undefined;
    this.attributesServcie.attributesList = undefined;
    this.workflowStatesService.allWorkflowsList = undefined;
    this.masterService.masterList = {};
  }
}
